import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

const root = ReactDOM.createRoot(
  document.getElementById("root")
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

if ("serviceWorker" in navigator) {
  window.addEventListener("load", async () => {
    try {
      const registration =
        await navigator.serviceWorker.register(
          "/magazzino/service-worker.js",
          {
            scope: "/magazzino/",
          }
        );

      let refreshing = false;

      navigator.serviceWorker.addEventListener(
        "controllerchange",
        () => {
          if (refreshing) return;
          refreshing = true;
          window.location.reload();
        }
      );

      const activateWaitingWorker = () => {
        if (!registration.waiting) return;

        registration.waiting.postMessage({
          type: "SKIP_WAITING",
        });
      };

      activateWaitingWorker();

      window.setInterval(() => {
        registration.update().catch(() => {});
      }, 5 * 60 * 1000);

      registration.addEventListener(
        "updatefound",
        () => {
          const newWorker = registration.installing;
          if (!newWorker) return;

          newWorker.addEventListener(
            "statechange",
            () => {
              if (
                newWorker.state === "installed" &&
                navigator.serviceWorker.controller
              ) {
                activateWaitingWorker();
              }
            }
          );
        }
      );
    } catch (error) {
      console.error(
        "Registrazione service worker fallita:",
        error
      );
    }
  });
}
